import { Navigate } from "react-router-dom"
import MainLayout from "../Component/Layout"

const ProtectedRouteAuth = ({ isLoggedIn }) => {

  return isLoggedIn ? <MainLayout /> : <Navigate to='/login' />
}

export default ProtectedRouteAuth
